namespace Nobox {
    export interface ListFile {
        Base64?: string;
        Type?: string;
        RoomId?: string;
    }
}
